
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorOrMotorStep as ObiElectricGeneratorOrMotorStepElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-or-motor-step.js';
 
 
 

 
 export const ObiElectricGeneratorOrMotorStep = createComponent({
   react: React,
   tagName: 'obi-electric-generator-or-motor-step',
   elementClass: ObiElectricGeneratorOrMotorStepElement,
   events: {
     
   }
  });
 
 